<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="sam-image"
    :style="cssStyle"
    data-samora
    v-bind="$attrs"
    v-on="$listeners"
    v-html="require(`../../../images/${image}.svg`)"
  />
</template>

<script>
export default {
  name: 'SamImage',
  props: {
    /**
     * The SamImage name that should be displayed
     */
    image: {
      type: String,
      required: true,
      default: 'eleven',
    },
    /**
     * Image height
     */
    imageHeight: {
      type: String,
      required: false,
      default: '200px',
    },
  },
  computed: {
    cssStyle() {
      const style = {};

      if (this.imageHeight) {
        style['--image-height'] = this.imageHeight;
      }

      return style;
    },
  }
};
</script>

<style lang="scss" scoped>
.sam-image {
  :deep(svg) {
    height: var(--image-height);
    width: auto;
  }
}
</style>
